import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AgGrid from '../../shared/agGrid/agGrid.component';
import JournalPillTypes from './journalPillTypes';
import * as actions from './store/actions'; // eslint-disable-line import/no-namespace
import SearchBar from '../../shared/searchBar/searchBar.component';
import {
  alignCenterCellStyle,
} from '@common/cellStyles';
import { journalsPropTypes, localJournalsPropTypes, journalsDetailPropTypes } from '../../shared/propTypes';
import { journalGlobalColumnDefs, journalLocalColumnDefs, journalsDetailColumnDefs } from '../../shared/columnDefinitions/journals';

const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

class JournalTable extends PureComponent {
  static propTypes = {
    activePill: PropTypes.string.isRequired,
    journalsCollection: journalsPropTypes,
    localJournalsCollection: localJournalsPropTypes,
    journalsDetailCollection: journalsDetailPropTypes,
    journalTable: PropTypes.shape({
      journalTableFilter: PropTypes.string,
    }),
    setJournalTableFilter: PropTypes.func.isRequired,
    unsetJournalTableFilter: PropTypes.func.isRequired,
  };

  render() {
    const {
      activePill,
      journalsCollection,
      localJournalsCollection,
      journalsDetailCollection,
      journalTable,
      setJournalTableFilter,
      unsetJournalTableFilter,
    } = this.props;

    const { journalTableFilter } = journalTable;

    let collection;
    let columnDefs;

    switch (activePill) {
      case JournalPillTypes.JOURNAL:
        collection = journalsCollection;
        columnDefs = journalGlobalColumnDefs;
        break;
      case JournalPillTypes.LOCAL_JOURNAL:
        collection = localJournalsCollection;
        columnDefs = journalLocalColumnDefs;
        break;
      case JournalPillTypes.JOURNALS_DETAIL:
        collection = journalsDetailCollection;
        columnDefs = journalsDetailColumnDefs;
        break;
      default:
        collection = null;
        columnDefs = null;
    }

    return (
      <div className="journal-table">
        <div className="journal-table-header row">
          <div className="col-5 ml-auto">
            <SearchBar
              onCancel={unsetJournalTableFilter}
              onSearch={setJournalTableFilter}
              value={journalTableFilter}
            />
          </div>
        </div>

        <div className="journal-table-grid">
          <AgGrid
            columnDefs={columnDefs}
            defaultColDef={defaultColumnDefs}
            rowData={collection}
            quickFilterText={journalTableFilter}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ provision }) {
  return {
    journalsCollection: provision.general.journals,
    journalTable: provision.journalTable,
    localJournalsCollection: provision.general.localJournals,
    journalsDetailCollection: provision.general.journalsDetail,
  };
}

export default connect(mapStateToProps, actions)(JournalTable);
